/*
 * @providesModule WithdrawalPlaythroughInfo
 */

import {View, StyleSheet} from 'react-native';
import SkillzSVG from 'SkillzSVG';
import {SkillzText} from '@skillz/ui';
import SkillzStyle from 'SkillzStyle';
import {_m} from 'INTL';
import React from 'react';
import ClientPropertyConstants from 'ClientPropertyConstants';

const {fontRegular} = SkillzStyle.fullStyles;

type WithdrawalPlaythroughInfoProps = {
  canWithdraw: boolean;
};

const WithdrawalPlaythroughInfo = ({
  canWithdraw,
}: WithdrawalPlaythroughInfoProps) => {
  const playthroughEnabled = ClientPropertyConstants.getPlaythroughEnabled();
  if (!playthroughEnabled) {
    return null;
  }

  const standardMessage = _m('Deposited funds must be played in matches before\n you can withdraw them.');

  return (
    <View
      style={
        canWithdraw
          ? styles.playthroughInfoContainerCanWithdraw
          : styles.playthroughInfoContainerCantWithdraw
      }
    >
      <View style={styles.playthroughInfoContentContainer}>
        <SkillzSVG
          source={canWithdraw ? 'italic_info_gray.svg' : 'italic_info_brown.svg'}
          style={styles.infoIcon}
        />
        <SkillzText style={styles.playthroughInfoText}>{standardMessage}</SkillzText>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  playthroughInfoContainerCantWithdraw: {
    backgroundColor: '#FFF6E2',
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 2,
  },

  playthroughInfoContainerCanWithdraw: {
    borderColor: '#DFDFDF',
    borderWidth: 1,
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 2,
  },

  playthroughInfoContentContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 8,
  },

  playthroughInfoText: {
    fontSize: 12,
    ...fontRegular,
    color: '#333333',
  },

  infoIcon: {
    width: 15,
    height: 15,
  },
});

export default WithdrawalPlaythroughInfo;
